<template>
  <div class="group-rounded-box my-3 mx-4">
    <span class="title">Filter by</span>

    <!-- ROW -->
    <div class="row">
      <!-- RULE NAME SEARCH -->
      <div class="col-md-3" :class="{ 'mt-2': $breakpoint.mdAndDown }">
        <label for="selectTerminal">Name</label>
        <div class="position-relative">
          <el-input
            v-model="currentNameFilter"
            @input="nameSearchDebounce"
            :clearable="true"
        />
        </div>
      </div>
      <!-- TERMINAL SELECTION -->
      <div class="col-md-3" :class="{ 'mt-2': $breakpoint.mdAndDown }">
        <label for="selectTerminal">Terminals</label>
        <div class="position-relative">
          <el-select
            @change="changeTerminals"
            v-model="selectedTerminals"
            value-key="_id"
            placeholder="Select All"
            multiple
            filterable
            collapse-tags
            clearable
          >
            <el-option class="font-weight-bold" :value="SELECT_ALL"> </el-option>
            <el-option
              v-for="item in getTerminalChanges"
              :key="item._id"
              :label="item.name"
              :value="item"
            ></el-option>
          </el-select>
        </div>
      </div>

      <!-- PRODUCT SELECTION -->
      <div class="col-md-3" :class="{ 'mt-2': $breakpoint.mdAndDown }">
        <div v-if="currentTab !== 'BIO_COST_ADDITIONS'">
          <label for="selectProduct">Products</label>
          <div class="position-relative">
            <el-select
              class="el-olf"
              @change="changeProducts"
              v-model="selectedProducts"
              value-key="_id"
              placeholder="Select All"
              multiple
              filterable
              collapse-tags
              clearable
            >
              <el-option class="font-weight-bold" :value="SELECT_ALL"> </el-option>
              <el-option v-for="item in fuelList" :key="item._id" :label="item.name" :value="item"></el-option>
            </el-select>
          </div>
        </div>
        <div v-else>
          <label for="selectProduct">Networks</label>
          <div class="position-relative">
            <el-select
              class="el-olf"
              @change="changeNetworks"
              v-model="selectedNetworks"
              value-key="_id"
              placeholder="Select All"
              multiple
              filterable
              collapse-tags
              clearable
            >
              <el-option class="font-weight-bold" :value="SELECT_ALL"> </el-option>
              <el-option v-for="item in networkList" :key="item._id" :label="item.name" :value="item"></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="col-md-3" :class="{ 'mt-2': $breakpoint.mdAndDown }" style="padding-top:23px;">
        <button 
          class="btn btn-actionable"
          @click="resetFilters"
        >
          Reset Filters
        </button>
      </div>
    <!-- ROW -->
    </div>
  </div>
</template>

<script>
import breakpoint from '@/mixins/index';
import { mapGetters, mapActions } from 'vuex';
import { debounce } from "lodash";

export default {
  mixins: [breakpoint],
  data () {
    return {
      SELECT_ALL: "Select All",
      currentNameFilter: "",
      currentTab: ""
    }
  },
  created: async function(){
    // if (this.customerList && this.customerList.length < 1) await this.$store.dispatch('accounts/getRelationships');
    if(this.getSearchableBool){
      this.triggerRefresh();
    }
    this.currentTab = this.$store.getters["rules/getCurrentTab"] || ""
    this.currentNameFilter = this.$store.getters["rules/getNameFilter"].name || "";
  },
  computed:{
    ...mapGetters('rules', ['getNameFilter']),
    ...mapGetters('fuelsType', ['getFuelsType']),
    ...mapGetters('terminals', ['getTerminalChanges']),
    ...mapGetters('metadata', ['networks']),
    networkList: {
      get: function() {
        return this.networks;
      }
    },
    fuelList: {
      get: function() {
        return this.getFuelsType.filter(product => product.type === 'SPOT');
      }
    },
    selectedTerminals: {
      get() {
        return this.$store.getters["rules/getSelectedTerminalFilter"].terminals;
      },
      set(val) {
        this.setTerminalFilter(val);
      }
    },
    selectedNetworks: {
      get() {
        return this.$store.getters["rules/getSelectedNetworkFilter"].networks;
      },
      set(val) {
        this.setNetworkFilter(val);
      }
    },
    selectedProducts: {
      get() {
        return this.$store.getters["rules/getSelectedProductFilter"].products;
      },
      set(val) {
        this.setProductFilter(val);
      }
    }
  },
  methods: {
    ...mapActions('rules', ['setTerminalFilter', 'setNetworkFilter', 'setProductFilter', 'setNameFilter']),
    nameSearchDebounce: debounce(function(val) {
      this.setNameFilter(val);
      this.$emit("emit-rule-refresh");
    }, 600),
    changeTerminals(val) {
      if (val.includes(this.SELECT_ALL)) {
        this.selectedTerminals = this.getTerminalChanges;
      } else {
        this.selectedTerminals = val;
      }
      this.$emit("emit-filter-refresh");
      this.$emit("emit-rule-refresh");
    },
    changeNetworks(val) {
      if (val.includes(this.SELECT_ALL)) {
        this.selectedNetworks = this.networkList;
      } else {
        this.selectedNetworks = val;
      }
      this.$emit("emit-filter-refresh");
      this.$emit("emit-rule-refresh");
    },
    changeProducts(val) {
      if (val.includes(this.SELECT_ALL)) {
        this.selectedProducts = this.fuelList
      } else {
        this.selectedProducts = val;
      }
      this.$emit("emit-filter-refresh");
      this.$emit("emit-rule-refresh");
    },
    resetFilters() {
      this.setTerminalFilter([]);
      this.setNetworkFilter([]);
      this.setProductFilter([]);
      this.setNameFilter("");
      this.$emit("emit-filter-refresh");
      this.$emit("emit-rule-refresh");
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
